<template>
   <div class="container-fluid team py-6">
            <div class="container">
                <div class="text-center wow bounceInUp" data-wow-delay="0.1s">
                    <small class="d-inline-block fw-bold text-dark text-uppercase bg-light border border-primary rounded-pill px-4 py-1 mb-3">{{ $t('ourTeams') }}</small>
                    <h1 class="display-5 mb-5">{{ $t('teamPageTitle') }}</h1>
                </div>
                <div class="row g-4">
                    <div v-for="team in teams" :key="team.id" class="col-lg-3 col-md-6 wow bounceInUp" data-wow-delay="0.1s">
                        <div class="team-item rounded">
                            <img class="img-fluid rounded-top " :src="getImageUrl(team.person_image_url)" alt="" style="height: 350px; object-fit: cover;">
                            <div class="team-content text-center py-3 bg-dark rounded-bottom">
                                <h4 class="text-primary">{{ team.name }}</h4>
                                <p class="text-white mb-0">{{ team.description }}</p>
                            </div>
                            <div class="team-icon d-flex flex-column justify-content-center m-4">
                                <a class="share btn btn-primary btn-md-square rounded-circle mb-2" href=""><i class="fas fa-share-alt"></i></a>
                                <a class="share-link btn btn-primary btn-md-square rounded-circle mb-2" href=""><i class="fab fa-facebook-f"></i></a>
                                <a class="share-link btn btn-primary btn-md-square rounded-circle mb-2" href=""><i class="fab fa-twitter"></i></a>
                                <a class="share-link btn btn-primary btn-md-square rounded-circle mb-2" href=""><i class="fab fa-instagram"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
    import { mapActions, mapGetters } from "vuex";
    import mediaUrl from "../utils/mediaUrl";

    export default {
        computed: mapGetters(["teams"]),
        methods : {
        ...mapActions(['getTeacher']),
        getImageUrl(imageUrl) {
          return mediaUrl(imageUrl);
        },
        },
        mounted() {
            this.getTeacher()
            console.log(this.teams)
        }
    }
</script>

<style>

</style>